// native
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, tap, switchMap, retryWhen, delayWhen, take } from 'rxjs/operators';

// service
import { ToastService } from './toast.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!window.navigator.onLine) {
      this.toastService.showNoInternet();

      return throwError(new HttpErrorResponse({ error: 'Internet connection is required.' }));
    }

    return next.handle(request).pipe(catchError((response: HttpErrorResponse) => {
      switch (response.status) {
        case 403:
          if (response.error?.error === 'inactive_subscription')
            window.location.reload();
          return throwError(response);
        case 429:
          return this.getRateLimitResetTimer(response).pipe(
            tap(() => console.log('Retrying request...')),
            switchMap(() => next.handle(request.clone())),
            retryWhen((errors) => errors.pipe(
              delayWhen(response => this.getRateLimitResetTimer(response)),
              take(5)
            ))
          );
        case 503:
          return this.getRetryAfterTimer(response).pipe(
            tap(() => console.log('Retrying request...')),
            switchMap(() => next.handle(request.clone())),
            retryWhen((errors) => errors.pipe(
              delayWhen(response => this.getRetryAfterTimer(response)),
              take(5)
            ))
          );
        default:
          return throwError(response);
      }
    }));
  }

  protected getRateLimitResetTimer(response: HttpErrorResponse): Observable<number> {
    const resetTime = parseInt(response.headers.get('RateLimit-Reset'), 10);
    const nowTime = Date.now() / 1000;
    let dueTime = resetTime - nowTime;
    dueTime = dueTime < 2 ? 2 : Math.ceil(dueTime);
    return timer(dueTime * 1000);
  }

  private getRetryAfterTimer(response: HttpErrorResponse): Observable<number> {
    let retryTime = parseInt(response.headers.get('Retry-After'), 10);
    retryTime = retryTime < 2 ? 2 : retryTime;
    return timer(retryTime * 1000);
  }
}